module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.ch/de_ch/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Haftungsausschluss",
	"footer.disclaimer.url": "https://www.grohe.ch/de_ch/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2017 GROHE Switzerland SA",
	"homepage.headline": "Konfigurator für GROHE Wassersysteme",
	"homepage.introtext": "Beantworten Sie bitte die folgenden Fragen, um das GROHE Wassersystem ganz nach Ihren persönlichen Bedürfnissen zu konfigurieren.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "Schauen Sie sich die Ergebnisse an.",
	"question1.question": "Verfügen Sie in Ihrer Küche über eine Versorgung mit kaltem und warmem Wasser?",
	"question1.option1.text": "Ich verfüge über eine Kalt- und Warmwasserversorgung  in meiner Küche.",
	"question1.option2.text": "Ich habe eine reine Kaltwasserversorgung mit installiertem Durchlauferhitzer.",
	"question2.question": "Welche Art von Wasser benötigen Sie?",
	"question2.option1.text": "Kochend heißes Wasser für die Zubereitung von Mahlzeiten und Getränken.",
	"question2.option2.text": "Gekühltes und mit Kohlensäure veredeltes Trinkwasser.",
	"question2.option3.text": "Gekühltes und mit Kohlensäure veredeltes Trinkwasser ebenso wie kochend heißes Wasser.",
	"question3.question": "Möchten Sie Ihre bestehende Küchenarmatur behalten?",
	"question3.option1.text": "Ja, ich möchte sie behalten.",
	"question3.option2.text": "Nein, ich möchte eine neue Armatur installieren lassen.",
	"question4.question": "Welche Armatur möchten Sie hauptsächlich nutzen?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Wählen Sie Ihre bevorzugte Auslauf-Form",
	"question5.option1.text": "L-förmiger Auslauf",
	"question5.option2.text": "U-förmiger Auslauf",
	"question5.option3.text": "C-förmiger Auslauf",
	"question6.question": "Welche Auslauf-Form gefällt Ihnen bei der Mono-Armatur am besten?",
	"question6.option1.text": "L-förmiger Auslauf",
	"question6.option2.text": "C-förmiger Auslauf",
	"question7.question": "Wählen Sie Ihre gewünschte Oberfläche aus",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Supersteel",
	"question8.question": "In welcher Größe benötigen Sie den Boiler?",
	"question8.option1.text": "M-Size (für 3 Liter kochendes Wasser)",
	"question8.option2.text": "L-Size (für 5,5 Liter kochendes Wasser)",
	"question9.question": "Möchten Sie zusätzlich einen Filter verwenden, der das Wasser weicher macht und weiter verbessert?",
	"question9.option1.text": "Ja",
	"question9.option2.text": "Nein",
	"results.title": "{productGroupsCount, plural, \none {Ihre Ergebnisse} \nother {Ihr Ergebnis}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Für die vollständige Installation benötigen Sie außerdem:",
	"results.newConfiguration.title": "Möchten Sie ein weiteres Wassersystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Produktnummer: #{number}",
	"results.product.button.productInformation": "Produktinformation",
	"results.product.button.dealerLocator": "Ausstellung finden",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Produktinformation",
	"results.product.dealer": "Ausstellung finden",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.de_ch.json
// module id = 766
// module chunks = 0